(function (angular) {
	'use strict';

	angular
		.module('marketingModule')
		.controller('FeeComparison', [
			FeeComparisonFunction
		]);

	function FeeComparisonFunction() {
		var feeComparison = this;

		feeComparison.collapseEtf = true;
		feeComparison.collapseAssetMgmt = true;
		feeComparison.collapseIpo = true;
		feeComparison.collapseOrigination = true;
	}
})(window.angular);